import React from "react"
import Toolbar from "./Toolbar"
import ToolbarItem from "./ToolbarItem"

interface BackgroundToolbarProps {
  backgroundUrls: string[]
  selectedIndex: number
  handleSelect: (index: number) => void
}

export default function BackgroundToolbar({
  backgroundUrls,
  selectedIndex,
  handleSelect,
}: BackgroundToolbarProps) {
  return (
    <Toolbar>
      {backgroundUrls.map((url, index) => (
        <ToolbarItem
          key={index}
          selected={index === selectedIndex}
          onClick={() => handleSelect(index)}
        >
          <img
            crossOrigin="anonymous"
            src={url}
            alt={"Background " + index}
          />
        </ToolbarItem>
      ))}
    </Toolbar>
  )
}
